import React from 'react';
import PaveLogo from '../view/containers/PaveLogo';

export const RenderLoader = () => (
  <div
    className="animate-bottom"
    style={{
      position: 'relative',
      width: '100%',
      height: 'calc(100vh)',
      flexDirection: 'column',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <PaveLogo
      className="overlay-bg-blur"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        fontSize: '102px',
        color: '#fff',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        letterSpacing: '4px',
        maxWidth: '200px',
        margin: 'auto',
      }}
    />
  </div>
);
